<template>
    <section v-if="!list_loading && !htp_importing">
        <div class="row">
            <div class="col-12 mb-4">
                <div class="card shadow p-2 position-relative list">
                    <div class="card-body">
                        <div class="d-sm-flex align-items-center justify-content-between mb-1 mt-3">
                            <h1 class="h3 mb-0 text-black page-title">{{ list.edit_id ? 'Editare listă':'Creare listă nouă' }}</h1>
                        </div>
                        <div class="row mb-2">
                            <div class="col-md-6 d-sm-flex align-items-center">
                                <input v-model="list.name" type="text" class="form-control  bg-light small border" placeholder="Jocurile mele de vânzare" maxlength="150" required>  
                            </div>
                            <div class="col-md-4 d-sm-flex align-items-center mt-3 mt-md-0 mb-2 mb-md-0 position-relative">
                                <h5 class="h5 mb-0 text-gray-800 d-inline d-md-block">Contact:</h5> 
                                <input v-model="list.contact" type="text" class="form-control bg-light small border ml-md-2 d-inline d-md-block" placeholder="Nr telefon / email / link profil" required>  
                                <span v-show="getContactType()=='phone'" class="position-mobile-absolute end-0 top-0 fs-6 fs-md-4 ml-2 mr-2 mr-md-0"><i class="fa-brands fa-whatsapp"></i></span>
                                <span v-show="getContactType()=='email'" class="position-mobile-absolute end-0 top-0 fs-6 fs-md-4 ml-2 mr-2 mr-md-0"><i class="fa-regular fa-envelope"></i></span>
                                <span v-show="getContactType()=='link'" class="position-mobile-absolute end-0 top-0 fs-6 fs-md-5 ml-2 mr-2 mr-md-0"><i class="fa-solid fa-arrow-up-right-from-square"></i></span>
                            </div>
                            <div v-if="list.image" class="col-md-2 align-items-center position-relative cursor-pointer">
                                <a :href="list.image+'&ik-attachment=true'" target="_blank" download="share">
                                    <img :src="list.image" :alt="list.name" class="w-100" />
                                    <span class="position-absolute end-0 end-md-50 bottom-0 bottom-md-50 translate-md-middle-reverse mb-2 mr-4 m-md-0 fs-1 text-white d-md-none hover-md-show"><i class="fa-solid fa-cloud-arrow-down"></i></span>
                                </a>
                            </div>
                        </div>
                        <textarea v-model="list.notes" class="w-100 bg-light border p-3" placeholder="Pachete sau oferte speciale, accept schimburi, alte informații"></textarea>
                        <div class="row">
                            <div class="col-md-4 text-md-center mt-3 mt-md-0">
                                <div class="form-check">
                                    <input v-model="list.delivery_personal" class="form-check-input" type="checkbox" value="" id="delivery_personal" checked>
                                    <label class="form-check-label" for="delivery_personal">
                                        Livrare personală <b>gratuită</b> în 
                                        <input v-model="list.delivery_personal_location" type="text" class="form-control bg-light small border" placeholder="București/Ilfov" :required="list.delivery_personal ? true : false">  
                                    </label>
                                </div>
                            </div>
                            <div class="col-md-8 text-md-center mt-3 mt-md-0">
                                <div class="form-check">
                                    <input v-model="list.delivery_courier" class="form-check-input" type="checkbox" value="" id="delivery_courier" checked>
                                    <label class="form-check-label" for="delivery_courier">
                                        Livrare prin curier 
                                        <select v-model="list.delivery_courier_cost">
                                          <option value="free">gratuită</option>
                                          <option value="buyer">suportată de cumpărator</option>
                                        </select>
                                        în 
                                        <input v-model="list.delivery_courier_location" type="text" class="form-control bg-light small border" placeholder="toată țara" :required="list.delivery_courier ? true : false">  
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mb-4">
                <div class="card shadow p-2 position-relative">
                    <div class="card-body">
                        <div v-if="list.edit_id" class="links">
                            <div class="align-items-center justify-content-between mb-1 mt-3">
                                <h5 class="h5 mb-md-0 text-gray-800">Salvează acest link pentru editare și nu îl da la nimeni:</h5>
                                <div class="input-group">
                                    <input :value="getEditLink()" onClick="this.select();" type="text" class="form-control bg-warning border-warning small border text-white" readonly>  
                                    <div class="input-group-append">
                                        <button @click="copyToClipboard" class="btn btn-primary btn-warning pt-1" type="button"><i class="text-white fa-solid fa-copy fs-5 fs-mobile-6"></i></button>
                                        <button @click="addBookmark" class="btn btn-primary btn-warning pt-1" type="button"><i class="text-white fa-solid fa-bookmark fs-5 fs-mobile-6"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="list.id" class="links">
                            <div class="align-items-center justify-content-between mb-5 mb-md-1 mt-3">
                                <h5 class="h5 mb-md-0 text-gray-800">Poți da share la acest link:</h5>
                                <div class="input-group">
                                    <input :value="getViewLink()" onClick="this.select();" type="text" class="form-control bg-success border-success small border text-white" readonly>  
                                    <div class="input-group-append">
                                        <button @click="openInNewTab" class="btn btn-primary btn-success pt-1" type="button"><i class="text-white fa-solid fa-magnifying-glass fs-5 fs-mobile-6"></i></button>
                                        <button @click="copyToClipboard" class="btn btn-primary btn-success pt-1" type="button"><i class="text-white fa-solid fa-copy fs-5 fs-mobile-6"></i></button>
                                        <ShareNetwork
                                            network="facebook"
                                            :url="getViewLink()"
                                            :title="getViewTitle()"
                                            :description="getViewDescription()"
                                          >
                                            <button class="btn btn-primary btn-success pt-1 rounded-0" type="button"><i class="text-white fa-brands fa-facebook fs-5 fs-mobile-6"></i></button>
                                        </ShareNetwork>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="text-mobile-center text-md-right">
                            <div v-if="list.status!='published'" class="d-inline-block" v-tooltip="{ content: 'Nu uita să activezi afișarea în căutări după ce ai finalizat lista!', trigger: 'hover click'}">
                                <div v-if="list.edit_id" class="form-check d-inline-block mr-3">
                                    <input v-model="list.status" true-value="published" false-value="active" class="form-check-input cursor-pointer" type="checkbox" value="" id="status" checked>
                                    <label class="form-check-label" for="status">
                                        afișează în căutări   
                                    </label>
                                </div>
                                <button class="btn btn-primary btn-success" type="button" v-on:click="saveList()">
                                    <div v-show="bgg_saving"><span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Se salvează</div>
                                    <div v-show="!bgg_saving">Salvează și continuă editarea</div>
                                </button>
                            </div>
                            <div v-else class="d-inline-block">
                                <div v-if="list.edit_id" class="form-check d-inline-block mr-3">
                                    <input v-model="list.status" true-value="published" false-value="active" class="form-check-input cursor-pointer" type="checkbox" value="" id="status" checked>
                                    <label class="form-check-label" for="status">
                                        afișează în căutări   
                                    </label>
                                </div>
                                <button class="btn btn-primary btn-success" type="button" v-on:click="saveList()">
                                    <div v-show="bgg_saving"><span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Se salvează</div>
                                    <div v-show="!bgg_saving">Salvează și continuă editarea</div>
                                </button>
                            </div>
                            <button v-if="list.edit_id" class="btn btn-white border border-dark ml-2 mt-2 mt-md-0" type="button" v-on:click="publishHTP()">
                                <div>Publică pe <img src="/img/logoHTP.svg" class="d-inline mt-n2" style="height:1.75em" /></div>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-md-6 mb-4">
                <div class="card shadow p-2 position-relative">
                    <div class="card-body">
                        <div class="mb-1 mt-3">
                            <span class="float-end cursor-pointer fs-7 ml-3 mt-1">
                                <input v-model="bgg_import_all" class="form-check-input ml-0 mr-1 position-relative" type="checkbox" value="" id="bgg_import_all">
                                <label class="form-check-label cursor-pointer" for="bgg_import_all">toată colecția</label>
                            </span>
                            <h5 class="h5 mb-0 text-gray-800">Importă jocuri din colecția BGG</h5>
                        </div>
                        <form @submit="getBGGCollection" class="d-inline-block form-inline mr-auto w-100 my-2 my-md-0 mw-100 navbar-search">
                            <div class="input-group">
                                <input v-model="bgg_username" type="text" class="form-control bg-light border-0 small" placeholder="Username BoardGameGeek "
                                    aria-label="Search" aria-describedby="basic-addon2">
                                <div class="input-group-append">
                                    <button class="btn btn-primary btn-success py-0 py-md-1" type="submit" :disabled="!bgg_username || bgg_importing">
                                        <div v-show="bgg_importing"><span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Se importă</div>
                                        <div v-show="!bgg_importing">Importă</div>
                                    </button>
                                </div>
                            </div>
                            <p class="mb-0 mt-2 small text-left" :class="{ 'text-danger': bgg_import_color=='danger', 'text-success': bgg_import_color=='success' }">{{ bgg_import_msg }}</p>
                        </form>
                    </div>
                </div>
            </div>


            <div class="col-md-6 mb-4">
                <div class="card shadow p-2 position-relative">
                    <div class="card-body">
                        <div class="d-sm-flex align-items-center justify-content-between mb-1 mt-3">
                            <h5 class="h5 mb-0 text-gray-800">
                                Adaugă 
                                <select v-model="add_type" class="h6 mb-0">
                                  <option value="game">un joc</option>
                                  <option value="bundle">un pachet</option>
                                  <option value="other">altceva</option>
                                </select>
                            </h5>
                        </div>
                        <div v-if="add_type=='game'" class="d-inline-block form-inline mr-auto w-100 my-2 my-md-0 mw-100 navbar-search">
                            <div class="">
                                <autocomplete
                                    url="https://boardgamegeek.com/xmlapi2/search" param="search" :customParams="{ type: 'boardgame' }"
                                    class="w-100"
                                    :classes="{input: 'w-100 form-control bg-light border-0 small'}" placeholder="Numele jocului"
                                    anchor="value"
                                    label="label"
                                    :debounce="300"
                                    :onShouldGetData="onSearchGame"
                                    :on-select="onSelectGame"
                                    ref="autocomplete">
                                </autocomplete>
                            </div>
                            <p class="mb-0 mt-2 small text-left" :class="{ 'text-danger': bgg_searching_color=='danger', 'text-success': bgg_searching_color=='success' }">{{ bgg_searching_msg }}</p>
                        </div>
                        <div v-if="add_type=='bundle'" class="d-inline-block form-inline mr-auto w-100 my-2 my-md-0 mw-100 navbar-search">
                            <form @submit="addBundle">
                                <div class="input-group">
                                    <input v-model="bundle_name" type="text" class="form-control bg-light border-0 small" placeholder="Nume pachet " aria-label="Bundle" aria-describedby="basic-addon2">
                                    <div class="input-group-append z-0">
                                        <button class="btn btn-primary btn-success py-0 py-md-1" type="submit" :disabled="!bundle_name">Adaugă</button>
                                    </div>
                                </div>
                                <p class="mb-0 mt-2 small text-left"></p>
                            </form>
                        </div>
                        <div v-if="add_type=='other'" class="d-inline-block form-inline mr-auto w-100 my-2 my-md-0 mw-100 navbar-search">
                            <form @submit="addOther">
                                <div class="input-group">
                                    <input v-model="other_name" type="text" class="form-control bg-light border-0 small" placeholder="Nume playmat, accesorii, etc. " aria-label="Other" aria-describedby="basic-addon2">
                                    <div class="input-group-append z-0">
                                        <button class="btn btn-primary btn-success py-0 py-md-1" type="submit" :disabled="!other_name">Adaugă</button>
                                    </div>
                                </div>
                                <p class="mb-0 mt-2 small text-left"></p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <draggable v-if="!bgg_importing && !sorting" :list="games" group="games" @start="startDragging" @end="endDragging" :disabled="!sort_mode" delay="300" delay-on-touch-only="true" ghost-class="ml-5" animation="150">    
            <div v-for="(item, i) in games" :key="games[i].id" :bgg-id="games[i].id" class="item" :class="{'bundle':item.type=='bundle'}">
                <edit-item :item="item" :index="i"></edit-item>
            </div>
        </draggable>
        <div v-else class="loading inline m-2"><span></span><p>actualizăm lista...</p></div>

        <div class="bar z-1000">
            <div v-show="!sort_mode">
                <button class="btn btn-primary btn-success btn-sm" type="button" v-on:click="saveList()">
                    <div v-show="bgg_saving"><span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span> Se salvează</div>
                    <div v-show="!bgg_saving">Salvează</div>
                </button>
                <button @click="sortMode" v-tooltip="'Activează modul sortare'" class="btn btn-secondary btn-sm btn-warning mx-3" type="button">Sortează</button>
                <button @click="scrollToTop" v-tooltip="'înapoi sus'" class="btn btn-secondary btn-sm" type="button"><i class="fa-solid fa-circle-up"></i></button>
            </div>
            <div v-show="sort_mode">
                <popper trigger="clickToOpen" :options="{ placement: 'top-start', modifiers: {} }">
                    <div class="popper bg-danger text-white p-3">
                      <div>Sigur vrei să ștergi<br/> toate elementele din listă?</div>
                      <div class="mx-auto d-inline-block mt-2" role="button" v-on:click="deleteAllItems()"><i class="text-white fa-solid fa-square-check fs-3"></i></div>
                    </div>

                    <div role="button" slot="reference" class="d-inline">
                        <div v-tooltip="{ content: 'Șterge toate elementele din listă', trigger: 'hover'}" class="btn btn-secondary btn-sm mr-3 bg-danger">
                            <i class="text-white fa-solid fa-trash-can mr-1"></i><i class="text-white fa-solid fa-list"></i>
                        </div>
                    </div>
                </popper>
                <button @click="sortList('alphabetical')" v-tooltip="{ content: 'Sortează lista alfabetic', trigger: 'hover click'}" class="btn btn-secondary btn-warning btn-sm mr-3" type="button"><i class="fa-solid fa-font"></i></button>
                <button @click="sortList('rating')" v-tooltip="{ content: 'Sortează lista după nota de pe BGG', trigger: 'hover click'}" class="btn btn-secondary btn-warning btn-sm mr-3" type="button"><i class="fa-solid fa-star"></i></button>
                <button @click="sortList('price')" v-tooltip="{ content: 'Sortează lista după preț', trigger: 'hover click'}" class="btn btn-secondary btn-warning btn-sm mr-3" type="button"><i class="fa-solid fa-sack-dollar"></i></button>
                <button @click="sortList('discount')" v-tooltip="{ content: 'Sortează lista după reducere', trigger: 'hover click'}" class="btn btn-secondary btn-warning btn-sm mr-3" type="button"><i class="fa-solid fa-percent"></i></button>
                <button @click="sortMode" v-tooltip="'Dezactivează modul sortare'" class="btn btn-secondary btn-sm" type="button"><i class="fa-solid fa-xmark"></i></button>
            </div> 
        </div>

        <input type="file" @change="uploadImage" ref="image" class="d-none" accept=".jpg,.jpeg,.png">
    </section>
    <div v-else class="loading"><span></span><p>{{list_loading?'tragem lista...':''}}{{htp_importing?'verificăm prețuri...':''}}</p></div>
</template>
<script>
    import Vue from "vue";
    import HelperMixin from "../../mixins/HelperMixin";
    import EditItem from '../EditItem'
    import PriceHistoryMixin from "../../mixins/PriceHistoryMixin";
    import draggable from 'vuedraggable'
    import Popper from 'vue-popperjs';
    import 'vue-popperjs/dist/vue-popper.css';
    import Autocomplete from 'vue2-autocomplete-js'
    import VueSocialSharing from 'vue-social-sharing'
    import VTooltip from 'v-tooltip'
    import ImageKit from "imagekit-javascript"
    import LineChart from '../LineChart.vue'

    Vue.use(VueSocialSharing);
    Vue.use(VTooltip);

    export default {
        name: "CreateList",
        components: { EditItem, draggable, 'popper': Popper, Autocomplete, LineChart },
        mixins: [HelperMixin, PriceHistoryMixin],
        props: ['bgg_user', 'list_id'],
        computed: { },
        data() {
            return {
                games: [],
                bgg_username: '',
                bgg_import_all : false,
                bgg_importing: false,
                bgg_import_msg: '',
                bgg_import_color: 'danger',
                list_loading: true,
                htp_importing: false,
                bgg_saving: false,
                sort_mode: false,
                add_type: 'game',
                other_name: '',
                bundle_name: '',
                upload: { id: null, bundle_id: null, type: 'thumbnail', uploading: false },
                list: { id: null, edit_id: null, name: '', contact: '', notes: '', delivery_personal:true, delivery_personal_location:'', delivery_courier: true, delivery_courier_location:'', delivery_courier_cost:'free', status:'active'}
            }
        },
        mounted() {
            var _this = this;

            if(_this.bgg_user) {
                _this.bgg_username = _this.bgg_user;
                this.getBGGCollection();    
            }
            
            if(_this.list_id) {
                this.getList(_this.list_id);
                if(window.mixpanel) {
                    window.mixpanel.track('EditList', {list_id: _this.list_id});
                }
            } else {
                this.list_loading = false;
                if(window.mixpanel) {
                    window.mixpanel.track('CreateList');
                }
            }

        },
        methods: {
            getBGGCollection: function(event, attempt) {
                if (event !== undefined) {
                    event.preventDefault();
                }
                if(typeof attempt == 'undefined') {
                    attempt = 0;
                }

                var _this = this;
                if(!_this.bgg_username) {
                    return;
                }

                var request_collection = new XMLHttpRequest();
                request_collection.onreadystatechange = function() {
                    if (request_collection.readyState === 4) {
                        switch(request_collection.status) {
                            case 202:
                                _this.bgg_import_color = 'success';
                                _this.bgg_import_msg = 'Pentru colecții mai mari poate dura până la câteva minute...';
                                let timeout = 5000 + (parseInt(attempt)*2000);
                                setTimeout(function(scope, event, attempt) {
                                     scope.getBGGCollection(event, parseInt(attempt)+1);
                                }, timeout, _this, event, attempt);
                                break;
                            case 200:
                                var game_ids = [];
                                var xml = $( request_collection.responseText );
                                $(xml.find("item").get().reverse()).each(function(index) {
                                    var name = $(this).find('name').text();
                                    var value = name;
                                    if(typeof $(this).find('yearpublished').text() != 'undefined' && $(this).find('yearpublished').text()) {
                                      name+=" ("+$(this).find('yearpublished').text()+")";
                                    } 
                                    var numplays = parseInt($(this).find('numplays').text());
                                    var condition = 'likenew';
                                    if(numplays>0 && numplays <3) {
                                        condition = 'verygood';
                                    } else if(numplays>=3 && numplays <20){
                                        condition = 'good';
                                    } else if(numplays>=20) {
                                        condition = 'acceptable';
                                    }

                                    var game_exists = false;
                                    var id = parseInt($(this).attr('objectid'));
                                    _this.games.forEach(function(game, i) {
                                        if(game.id == id) {
                                            game_exists = true;
                                        }
                                    });
                                    if(!game_exists) {
                                        _this.games.unshift({id: id, name: name, bgg_name: value, status: "available", thumbnail: $(this).find('thumbnail').text(), numplays: numplays, condition:condition, bgg_data:false});
                                        game_ids.push(id);    
                                    }
                                });
                                if(typeof game_ids[0] == 'undefined') {
                                    _this.bgg_import_color = 'danger';
                                    _this.bgg_import_msg = 'Nu există jocuri noi de importat. '+(_this.bgg_import_all?'':'Bifează în BGG "For Trade" la jocurile pe care vrei să le vinzi!');
                                    _this.bgg_importing = false;
                                } else {
                                    _this.getBGGData(game_ids);
                                } 

                                if(window.mixpanel) {
                                    window.mixpanel.track('ImportList', {user: _this.bgg_username});
                                }
                                break;
                            default:
                                _this.bgg_import_color = 'danger';
                                _this.bgg_import_msg = 'A avut loc o eroare, verificați userul și mai încercați o dată.';
                                _this.bgg_importing = false;
                        }
                    }
                }
                _this.bgg_import_msg = '';
                _this.bgg_importing = true;
                request_collection.open('GET', 'https://boardgamegeek.com/xmlapi2/collection?username='+_this.bgg_username+(_this.bgg_import_all?'&own=1':'&trade=1'), true);
                request_collection.setRequestHeader("Authorization", "Bearer c93f1c0c-62c6-46aa-a2f5-e8f8dfd48281");
                request_collection.send();

            },
            getBGGData: function (game_ids) {
                var _this = this;

                let rest_game_ids = game_ids.slice(20);
                game_ids = game_ids.slice(0, 20);
                if(rest_game_ids.length) {
                    _this.getBGGData(rest_game_ids);
                }

                var request_data = new XMLHttpRequest();
                request_data.onreadystatechange = function() {
                    if (request_data.readyState === 4 && request_data.status == 200) {
                        var xml = $( request_data.responseText );
                        var items = [];
                        xml.find("item").each(function(i) {
                            var item = $(this);
                            var id = item.attr('id');
                            _this.games.forEach(function(game, i) {
                                if(game.id == id) {
                                    // Set name & bgg_name if missing (game added by bgg url)
                                    if (!game.name) {
                                        game.name = item.find('name[type="primary"]:first').attr('value');
                                    }
                                    if (!game.bgg_name) {
                                        game.bgg_name = game.name + ' (' + item.find('yearpublished:first').attr('value') + ')';
                                    }
                                    game.bgg_data = true;
                                    game.thumbnail = item.find('thumbnail:first').text();
                                    game.no_thumbnail = game.thumbnail!=""?false:true;
                                    game.description = item.find('description:first').text().replaceAll('&#10;', '<br/>');
                                    game.minplayers = item.find('minplayers:first').attr('value');
                                    game.maxplayers = item.find('maxplayers:first').attr('value');
                                    game.minplaytime = item.find('minplaytime:first').attr('value');
                                    game.maxplaytime = item.find('maxplaytime:first').attr('value');
                                    game.minage = item.find('minage:first').attr('value');

                                    game.rating = Math.round(item.find('statistics ratings average:first').attr('value') * 10) / 10;
                                    game.weight = Math.round(item.find('statistics ratings averageweight:first').attr('value') * 100) / 100;

                                    game.mechanics = [];
                                    item.find('link[type="boardgamemechanic"]').each(function(mechanic) {
                                        game.mechanics.push($(this).attr('value'));
                                    });
                                    game.type = item.attr('type');
                                    if(game.type=='boardgameexpansion') {
                                        game.main_game = { id: item.find('link[inbound="true"]:first').attr('id'), name: item.find('link[inbound="true"]:first').attr('value') };
                                    } else {
                                        game.main_game = null;
                                    }

                                    game.versions = [{ name: 'Default', year: '', thumbnail: game.thumbnail }];
                                    item.find('versions item[type="boardgameversion"]').each(function(version) {
                                        if($(this).find('thumbnail').text()) {
                                            game.versions.push({ name: $(this).find('name[type="primary"]').attr('value'), year: $(this).find('yearpublished').attr('value'), thumbnail: $(this).find('thumbnail').text() });
                                        }
                                    });

                                    Vue.set(_this.games, i, game);
                                }
                            });
                            
                        });

                        _this.getHTPData(game_ids);
                    }
                }
                request_data.open('GET', 'https://boardgamegeek.com/xmlapi2/thing?stats=1&versions=1&id='+game_ids.join(','), true); 
                request_data.setRequestHeader("Authorization", "Bearer c93f1c0c-62c6-46aa-a2f5-e8f8dfd48281");
                request_data.send();

            },
            showPriceHistory: function (game_id) {
                var _this = this;
                _this.getPriceHistory(game_id, function(data) {
                    //console.log(data.shops);
                    Vue.set(_this.price_history, game_id, {
                        labels: _this.getMonthsNames(),
                        datasets: [
                            {
                                label: 'Nou în magazine',
                                borderColor: 'rgba(25,135,84,1)',
                                backgroundColor: 'rgba(25,135,84,0.75)',
                                data: data.shops,
                                parsing: {
                                    xAxisKey: 'month_name',
                                    yAxisKey: 'min'
                                }
                            },
                            {
                                label: 'SH pe Din Raft',
                                borderColor: 'rgba(240,154,4,1)',
                                backgroundColor: 'rgba(240,154,4,0.75)',
                                data: data.dinraft,
                                parsing: {
                                    xAxisKey: 'month_name',
                                    yAxisKey: 'min'
                                }
                            },
                            {
                                label: 'SH pe GeekMarket',
                                borderColor: 'rgba(13,110,253,1)',
                                backgroundColor: 'rgba(13,110,253,0.75)',
                                data: data.geekmarket,
                                parsing: {
                                    xAxisKey: 'month_name',
                                    yAxisKey: 'min'
                                }
                            }
                        ]
                    });
                });
            },
            hidePriceHistory: function (game_id) {
                var _this = this;
                Vue.set(_this.price_history, game_id, null);
            },
            sortMode: function () {
                var _this = this;
                _this.sorting = true;
                
                if(_this.games.length<100) {
                    _this.sort_mode = !_this.sort_mode;
                    _this.sorting = false;
                } else {
                    setTimeout(() => {
                        _this.sort_mode = !_this.sort_mode;
                        _this.sorting = false;
                    }, 0);
                }
            },
            addBundle: function (event) {
                if (event !== undefined) {
                    event.preventDefault();
                }

                var _this = this;

                _this.games = [
                     {id: _this.makeid(32), type: 'bundle', name: _this.bundle_name, games:[], thumbnail: null, condition:'likenew', status:'available'},
                      ..._this.games
                ];
                _this.bundle_name = '';
            },
            addOther: function (event) {
                if (event !== undefined) {
                    event.preventDefault();
                }

                var _this = this;

                _this.games = [
                     {id: _this.makeid(32), type: 'other', name: _this.other_name, thumbnail: null, condition:'likenew', status:'available'},
                      ..._this.games
                ];
                _this.other_name = '';
            },
            selectThumbnail: function (id, bundle_id) {
                var _this = this;
                if(_this.upload.uploading) {
                    return;
                }

                _this.upload.id = id;
                _this.upload.bundle_id = bundle_id ? bundle_id : null;
                _this.upload.type = 'thumbnail';

                _this.$refs.image.click();
            },

            uploadImage: function (event) {
                var _this = this;

                if(typeof event.target.files[0] == 'undefined') {
                    return;
                }

                _this.upload.uploading = true;

                $.ajax({
                    method: "POST",
                    url: api_url+'/image/upload',
                    dataType: 'json',
                    processData : false,
                }).always(function(data){
                    if(typeof data.signature != "undefined") {
                        var imagekit = new ImageKit({
                            publicKey : "public_/dJ0yTXkTcS4kXK8pSG3ntg1W6Q=",
                            urlEndpoint : "https://ik.imagekit.io/nelv9y9yf"
                        });

                        imagekit.upload({
                            file : event.target.files[0],
                            folder: "/uploads/"+_this.upload.type+"/"+_this.getMonth(),
                            fileName: _this.upload.id+".jpg",
                            useUniqueFileName: "false",
                            transformation: JSON.stringify({
                                pre: 'w-1000'
                            }),
                            token: data.token,
                            expire: data.expire,
                            signature: data.signature
                        }, function(err, result) {
                            if(err) {
                                console.log(err);
                            } else {
                                let item_id = _this.upload.bundle_id ? _this.upload.bundle_id : _this.upload.id;
                                _this.games.some(function(game, i) {
                                    if(game.id == item_id) {
                                        if(_this.upload.bundle_id) {
                                            game.games.some(function(subitem, j) {
                                                if(subitem.id == _this.upload.id) {
                                                    subitem.thumbnail = result.url+'?t='+_this.makeid(8);
                                                    Vue.set(_this.games[i].games, j, subitem);
                                                    return true; 
                                                }
                                            });
                                        } else {
                                            game.thumbnail = result.url+'?t='+_this.makeid(8);
                                        }
                                        Vue.set(_this.games, i, game);
                                        return true;    
                                    }
                                });
                                _this.upload.uploading = false;
                            }
                        });

                    } else {
                        _this.upload.uploading = false;
                        console.log('Error upload image: ');
                        console.log(data);
                    }

                });

            },
            addListToDevice: function() {
                var _this = this;
                let edited_lists = localStorage.edited_lists;
                let already_saved = false;
                if(edited_lists) {
                    edited_lists = JSON.parse(edited_lists);
                    edited_lists.some(function(list, i) {
                        if(list.edit_id == _this.list.edit_id) {
                            edited_lists[i].name = _this.list.name;
                            already_saved = true;
                            return true;
                        }
                    });
                } else {
                    edited_lists = [];
                }
                if(!already_saved) {
                    edited_lists.unshift({id: _this.list.id, edit_id: _this.list.edit_id, name: _this.list.name});
                }
                localStorage.edited_lists = JSON.stringify(edited_lists);
            },
            viewImage: function (url) {
                console.log('TODO: open popup to view image '+url);
            },
            deleteGame: function (index) {
                this.games.splice(index, 1);
            },
            validateList: function() {
                var all_valid = true;
                $('.list input.border-danger').removeClass('border-danger');
                $('.list input[required="required"]').each(function() {
                    if(!$(this).val()) {
                        $(this).addClass('border-danger');
                        all_valid = false;
                    }
                });
                if(!all_valid) {
                    this.scrollToTop();
                }
                return all_valid;
            },
            saveList: function(callback) {
                var _this = this;
                if(!this.validateList()) {
                    return;
                }

                _this.bgg_saving = true;

                _this.list.image = this.getViewImage();

                $.ajax({
                    method: "POST",
                    url: api_url+ (_this.list.edit_id?'/list/update':'/list/create'),
                    //dataType: 'json',
                    processData : false,
                    data: JSON.stringify({ list: _this.list, games: _this.games })
                }).always(function(data){
                    if(typeof data.id != "undefined" && typeof data.edit_id != "undefined") {
                        _this.list.id = data.id;
                        _this.list.edit_id = data.edit_id;
                        _this.$router.push({ name: "edit-list", params: { list_id: _this.list.edit_id } }).catch(err => {});

                        document.title = 'Editare listă "'+_this.list.name+'" | '+app_name;    

                        _this.bgg_saving = false;

                        if(window.mixpanel) {
                            window.mixpanel.track('SaveList', {list_id: _this.list.id});
                        }

                        _this.addListToDevice();

                        if(typeof callback != 'undefined') {
                            callback();
                        }
                    }
                });
                
            },
            deleteAllItems: function() {
                this.games = [];
                this.sortMode();
            },

            getEditLink: function() {
                return window.location.protocol+'//'+window.location.host+'/list/'+this.list.edit_id+'/edit';
            },
            getViewLink: function() {
                return window.location.protocol+'//'+window.location.host+'/list/'+this.list.id;
            },
            getViewTitle: function() {
                return this.list.name+" | "+app_name;
            },
            getViewDescription: function() {
                return this.list.description;
            },

            getList: function (list_id) {
                var _this = this;
                $.ajax({
                    method: "POST",
                    url: api_url+'/list/get',
                    dataType: 'json',
                    processData : false,
                    data: JSON.stringify({ edit_id: list_id })
                }).always(function(data){
                    if(typeof data.id != "undefined") {
                        _this.list = JSON.parse(data.details);
                        _this.list.status = data.status;
                        _this.games = JSON.parse(data.games);
                        document.title = 'Editare listă "'+_this.list.name+'" | '+app_name;  

                        let game_ids = _this.games.map((game) => game.id); 

                        _this.addListToDevice();

                        _this.list_loading = false;
                        _this.htp_importing = true;

                        _this.getHTPData(game_ids); 
                    } else {
                        _this.list_loading = false;
                        _this.$router.push({ name: "create-list" }).catch(err => {});
                    }
                });
            },





            onSelectGame: function (selected){
                var _this = this;
                this.$refs.autocomplete.type = '';
                var game_exists = false;
                _this.games.forEach(function(game, i) {
                    if(game.id == selected.id) {
                        _this.bgg_searching_color = 'success';
                        _this.bgg_searching_msg = 'Jocul se află deja în listă!';
                        game_exists = true;
                    }
                });
                if(game_exists) {
                    return;
                }
                _this.bgg_import_msg = '';
                _this.bgg_importing = true;
                this.games = [
                     {id: selected.id, name: selected.value, bgg_name: selected.bgg_name, thumbnail: null, numplays: null, condition:'likenew', bgg_data:false, status:'available'},
                      ...this.games
                ];
                _this.getBGGData([selected.id])
            },
            

            startDragging: function(event) {
                if($(event.item).hasClass('bundle')) {
                    $('.nested-drag-area').each(function( index ) {
                        this.__vue__._sortable.options.disabled = true;
                    });
                }
            },
            endDragging: function(event) {
                if($(event.item).hasClass('bundle')) {
                    $('.nested-drag-area').each(function( index ) {
                        this.__vue__._sortable.options.disabled = false;
                    });
                }
            },
            copyToClipboard: function(event) {  
                $(event.target).parents('.input-group').find('input[type="text"').select();
                document.execCommand('Copy');   
            },
            openInNewTab: function(event) {
                window.open($(event.target).parents('.input-group').find('input[type="text"').val(), "_blank");
            },
            publishHTP: function() {
                var _this = this;

                _this.saveList(function() {
                    if(window.mixpanel) {
                        window.mixpanel.track('PublishList', {list_id: _this.list.id});
                    }
                    window.open("https://howtoplay.ro/connect?source=market-boardiacs&list="+_this.list.edit_id, "_blank");
                }); 
            },
            addBookmark: function() {
                if (window.sidebar && window.sidebar.addPanel) { // Firefox <23
                    window.sidebar.addPanel(document.title,window.location.href,'');
                } else if(window.external && ('AddFavorite' in window.external)) { // Internet Explorer
                    window.external.AddFavorite(location.href,document.title); 
                } else if(window.opera && window.print || window.sidebar && ! (window.sidebar instanceof Node)) { // Opera <15 and Firefox >23
                    triggerBookmark.attr('rel', 'sidebar').attr('title', document.title).attr('href', window.location.href);
                    return true;
                } else if(this.mobileAndTabletCheck()) {
                    alert('Puteți salva această pagină ca bookmark intrănd in meniu ⋮ și apăsând ☆');
                } else { // For the other browsers (mainly WebKit) we use a simple alert to inform users that they can add to bookmarks with ctrl+D/cmd+D
                    alert('Puteți salva această pagină ca bookmark apăsând ' + (navigator.userAgent.toLowerCase().indexOf('mac') != - 1 ? 'Command/Cmd' : 'CTRL') + ' + D.');
                }
            },
            mobileAndTabletCheck: function() {
              let check = false;
              (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
              return check;
            }
        }
    };
</script>
